// Central content — realistic, editable copy for Unnati AI
export const WHATSAPP_NUMBER = "919000000000"; // placeholder — replace with real number
export const CONTACT_EMAIL = "info@unevo.in";
export const LOCATION = "Ormanjhi Block, Ranchi, Jharkhand";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Modules", href: "#modules" },
  { label: "Languages", href: "#languages" },
  { label: "Vision", href: "#vision" },
  { label: "Impact", href: "#impact" },
];

export const MODULES = [
  {
    id: "ai-innovators",
    tag: "Flagship",
    title: "Next-Gen AI Innovators",
    desc: "Build, train and deploy real AI tools. From prompt craft to automation, learners become creators of technology — not just consumers.",
    image:
      "https://images.unsplash.com/photo-1656510922456-e9018507288f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG1vZGVybiUyMHRlY2hub2xvZ3klMjBncmlkfGVufDB8fHx8MTc4NTkzMTQwNnww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    id: "digital-artisans",
    tag: "Creative",
    title: "Digital Artisans",
    desc: "Turn craft into a global brand with design, content and social commerce skills built for the smartphone generation.",
    image:
      "https://images.unsplash.com/photo-1762160687270-1602d25749b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwY3JlYXRvciUyMGxhcHRvcCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTkzMTM5M3ww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    id: "culinary",
    tag: "Enterprise",
    title: "Culinary Entrepreneurship",
    desc: "From kitchen to cloud — recipes, food safety, pricing and online ordering to launch a profitable local food business.",
    image:
      "https://images.unsplash.com/photo-1636647511729-6703539ba71f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb29raW5nJTIwa2l0Y2hlbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTkzMTM5M3ww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    id: "smart-agri",
    tag: "AgriTech",
    title: "Smart Agriculture",
    desc: "Sensor-driven farming, weather intelligence and direct-to-market selling that lifts yields and incomes for rural families.",
    image:
      "https://images.unsplash.com/photo-1609252509027-3928a66302fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGFncmljdWx0dXJlJTIwaW5kaWF8ZW58MHx8fHwxNzg1OTMxMzkzfDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    id: "digital-marketing",
    tag: "Growth",
    title: "Digital Marketing Pro",
    desc: "SEO, social ads, WhatsApp funnels and analytics — get any local business found and booked online, from anywhere in India.",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-6",
  },
  {
    id: "dropshipping",
    tag: "Commerce",
    title: "Advanced Dropshipping Mastery",
    desc: "Source, list and scale an online store with zero inventory. Master logistics, ads and margins to sell across India.",
    image:
      "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxlLWNvbW1lcmNlJTIwcGFja2FnZXMlMjBzaGlwcGluZyUyMHdhcmVob3VzZXxlbnwwfHx8fDE3ODU5MzE0MDZ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Voice over keyboards",
    body: "Language should never be a wall. Every lesson speaks in the learner's mother tongue, so a farmer in Ormanjhi learns exactly like an engineer in Bengaluru.",
  },
  {
    n: "02",
    title: "Skills that pay by Friday",
    body: "We teach what the market rewards today — AI, commerce, agri-tech and craft — with a placement guarantee, not just a certificate on the wall.",
  },
  {
    n: "03",
    title: "Stay, don't migrate",
    body: "When opportunity arrives at the doorstep, families no longer split apart. We build livelihoods where roots already run deep.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1716471453667-94383b1e4859?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop";

// Hero carousel — real beneficiaries across age groups & modules
export const HERO_CAROUSEL = [
  {
    module: "Next-Gen AI Innovators",
    image:
      "https://images.pexels.com/photos/9159272/pexels-photo-9159272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    name: "Priya",
    age: 22,
    location: "Ranchi, Jharkhand",
    story: "Landed a remote data-annotation job with her new AI skills.",
  },
  {
    module: "Digital Artisans",
    image:
      "https://images.pexels.com/photos/36739400/pexels-photo-36739400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    name: "Sunita",
    age: 34,
    location: "Hazaribagh, Jharkhand",
    story: "Sells her clay art & pottery worldwide through a digital storefront.",
  },
  {
    module: "Culinary Entrepreneurship",
    image:
      "https://images.unsplash.com/photo-1621334721541-370a13974de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzdHJlZXQlMjBmb29kJTIwY29va2luZ3xlbnwwfHx8fDE3ODU5MzU4Njl8MA&ixlib=rb-4.1.0&q=85",
    name: "Rajesh",
    age: 29,
    location: "Dhanbad, Jharkhand",
    story: "Grew a street stall into a cloud kitchen doing 100+ orders a day.",
  },
  {
    module: "Smart Agriculture",
    image:
      "https://images.unsplash.com/photo-1766716946030-5869da2a0ead?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBtYW4lMjB1c2luZyUyMHBob25lJTIwcnVyYWx8ZW58MHx8fHwxNzg1OTM1ODg4fDA&ixlib=rb-4.1.0&q=85",
    name: "Devendra",
    age: 48,
    location: "Dumka, Jharkhand",
    story: "Uses weather & market-price tools to double his crop profits.",
  },
  {
    module: "Advanced Dropshipping Mastery",
    image:
      "https://images.unsplash.com/photo-1741275269355-4815dcd8b326?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBlbnRyZXByZW5ldXIlMjBwYWNraW5nJTIwcGFyY2VsfGVufDB8fHx8MTc4NTkzNTg2OXww&ixlib=rb-4.1.0&q=85",
    name: "Kavita",
    age: 25,
    location: "Bokaro, Jharkhand",
    story: "Runs a profitable e-commerce parcel business from her village home.",
  },
  {
    module: "Lifelong Learning for All",
    image:
      "https://images.unsplash.com/photo-1774437776063-004e4444c063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBlbGRlcmx5JTIwbGVhcm5pbmd8ZW58MHx8fHwxNzg1OTM1ODY5fDA&ixlib=rb-4.1.0&q=85",
    name: "Lakshmi",
    age: 62,
    location: "Deoghar, Jharkhand",
    story: "Mastered mobile banking & video calls — independent at 62.",
  },
];

// Global Languages — voice-first spoken fluency for global careers
export const LANGUAGES = [
  {
    id: "french",
    flag: "🇫🇷",
    name: "French",
    native: "Bonjour",
    tagline: "For hospitality, study abroad & the francophone economy.",
    level: "A1 → B2",
    weeks: "18 weeks",
    accent: "from-blue-500 to-red-500",
  },
  {
    id: "german",
    flag: "🇩🇪",
    name: "German",
    native: "Guten Tag",
    tagline: "For nursing, engineering & vocational jobs across the EU.",
    level: "A1 → B1",
    weeks: "20 weeks",
    accent: "from-yellow-400 to-red-600",
  },
  {
    id: "spanish",
    flag: "🇪🇸",
    name: "Spanish",
    native: "Hola",
    tagline: "For LATAM IT, tourism & the world's second most spoken language.",
    level: "A1 → B2",
    weeks: "16 weeks",
    accent: "from-yellow-500 to-red-500",
  },
  {
    id: "japanese",
    flag: "🇯🇵",
    name: "Japanese",
    native: "こんにちは",
    tagline: "For kaizen manufacturing, IT services & anime-scale opportunity.",
    level: "N5 → N3",
    weeks: "24 weeks",
    accent: "from-white to-red-500",
  },
  {
    id: "mandarin",
    flag: "🇨🇳",
    name: "Mandarin",
    native: "你好 Nǐ hǎo",
    tagline: "For trade, manufacturing & the world's largest workforce.",
    level: "HSK 1 → HSK 3",
    weeks: "22 weeks",
    accent: "from-red-500 to-yellow-500",
  },
  {
    id: "arabic",
    flag: "🇸🇦",
    name: "Arabic",
    native: "مرحبا",
    tagline: "For Gulf employment, oil-&-gas and hospitality careers.",
    level: "A1 → B1",
    weeks: "20 weeks",
    accent: "from-green-600 to-emerald-500",
  },
];
